export const APP_NAME = 'StoreHub'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'

export const TEXT = 1
export const SELECTOR = 2
export const CHECKBOX = 3
export const RADIO = 4
export const TEXTAREA = 5
export const DATE = 6
export const MENU = 7
export const TITLE = 8
export const FILE = 9
export const AI_VISUAL_CHECK = 10

export const NUMBER = "number"
export const OBJECT = "object"
export const STRING = "string"

/**
 * Niveles de anidación que admite una pregunta condicional, contando la raíz como 1.
 *
 * Existe acá, y no en cada vista, porque el tope tiene que ser EL MISMO en los tres
 * lugares que lo tocan, y hasta el 2026-09-07 no lo era: el backend cortaba en 5 al
 * subir la cadena para armar la descripción de la tarea generada
 * (`AutomaticFollowUpTicketService::PROFUNDIDAD_MAXIMA`), y ni el builder ni el render
 * tenían tope. Un cuestionario de 7 niveles se armaba y se respondía bien, pero la
 * tarea generada llegaba con la cadena recortada y sin decir que faltaba nada.
 *
 * El valor sale del backend, que es el que tiene el costo real: sube un nivel por
 * consulta. Si se cambia, se cambia en los dos lados.
 */
export const PROFUNDIDAD_MAXIMA_CONDICIONALES = 5


export const USER_SYS = {
    name: 'Sistema',
    lastname: 'automático',
    image: 'https://cdn-icons-png.flaticon.com/512/1587/1587565.png'
}

export const INIT_STATE_LOCALSTORAGE = {
    theme: {
        themeColor: "indigo",
        direction: "ltr",
        mode: "light",
        locale: "en",
        primaryColorLevel: 600,
        panelExpand: false,
        navMode: "transparent",
        layout: {
            type: "modern",
            sideNavCollapse: false
        }
    },
    auth: {
        session: {
            token: "",
            signedIn: false
        },
        user: {
            id: "",
            uuid: null,
            avatar: "",
            userName: "",
            userLastname: "",
            email: "",
            permissions: [],
            authority: [],
            haveNotifications: false,
            parameters: [],
            timezone: ""
        }
    },
    _persist: {
        version: -1,
        rehydrated: true
    }
};